<script>
import customerImg from "@/assets/img/customer.png";
import { Component, Vue } from "vue-property-decorator";
/* eslint-disable */
import Header from "@/components/common/Header";
import Login from "./login";
/* eslint-disable */

@Component
export default class BuyKnow extends Vue {
  sourceType = "senior";
  iframeVisible = false;
  created() {
    let path = this.$route.path;
    let params = this.$route.query;
    if (path === "/recharge") {
      this.sourceType = "recharge";
    } else {
      if (params && params.t && params.t === "0") {
        this.sourceType = "regular";
      } else if (params && params.t && params.t === "1") {
        this.sourceType = "senior";
      }
    }
  }
  isPC() {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      window.location.href =
        "https://tracking.newrank.cn/customerservicce/index/9";
    } else {
      this.iframeVisible = true;
      this.$refs.previewIframe.contentWindow.postMessage(true, "*");
      window.addEventListener("message", () => {
        this.iframeVisible = false;
      });
    }
  }
  render() {
    return (
      <section class="apibuyconfirm">
        <Header class="header-opacity">
          <div class="header-nav header-nav-api">
            <router-link tag="div" to="/" class="by-newrank" />
            <Login isRedirect={true} />
          </div>
        </Header>
        <div class="apibuyconfirm-bg">
          <div class="apibuyconfirm-main">
            <div class="apibuyconfirm-know">
              <div>
                {this.$slots.head ? (
                  this.$slots.head
                ) : (
                  <div class="apibuyconfirm-know-head">
                    <p class="apibuyconfirm-know-title">购买须知</p>
                    <p class="apibuyconfirm-know-title-small">BY NEWRANK</p>
                  </div>
                )}
                <div class="apibuyconfirm-know-desc">
                  {this.sourceType === "recharge" ? null : (
                    <div>
                      <p>
                        ·
                        {this.sourceType === "senior"
                          ? "您将获得新榜数据API服务，可以请求新榜所有公开接口；"
                          : "您将获得新榜数据API服务，可以请求新榜部分公开接口，详情可查看文档列表"}
                      </p>
                      <p>
                        ·
                        购买前请自行完成测试，若有疑问请先联系客服，此服务为虚拟物品，如非网站本身问题不可退款；
                      </p>
                      <p>· 购买仅为会员等级权限unit为额外赠送；</p>
                    </div>
                  )}
                  <p>· 如有开票需求请在购买完成后，在控制台中提交开票申请。</p>
                  {this.sourceType === "recharge" ? (
                    <div style={{ height: "203px" }}></div>
                  ) : null}
                </div>
              </div>
              <el-popover
                placement="bottom"
                width="184"
                trigger="hover"
              >
                <div>
                  <img src={customerImg} width={160} height={160} />
                </div>
                <el-button
                  plain
                  class="apibuyconfirm-know-kf"
                  slot="reference"
                >
                  联系客服
                </el-button>
              </el-popover>
            </div>
            {this.$slots.default}
          </div>
        </div>

        <iframe
          src="https://tracking.newrank.cn/pcCustomerService/9"
          title="test"
          frameBorder="0"
          class="apibuyconfirm-iframe"
          ref="previewIframe"
          v-show={this.iframeVisible}
        />
      </section>
    );
  }
}
</script>

<style lang="postcss">
@import "../../assets/css/_pub.css";
.apibuyconfirm {
  height: 100%;
  &-iframe  {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 500;
  }
  &-bg {
    height: 65%;
    width: 100%;
    background: url(~@/assets/img/buy.png) center/cover no-repeat;
    position: relative;
  }
  &-main {
    display: flex;
    width: 1170px;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 40%;
  }
  &-know {
    background-color: var(--white);
    width: 306px;
    border-radius: 8px;
    padding: 40px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 3px 20px rgba(153, 153, 153, 0.4);
    &-head {
      border-bottom: 1px dotted #ccc;
      text-align: center;
      padding-bottom: 28px;
    }
    &-title {
      font-size: 32px;
      &-small {
        font-size: 14px;
        color: #999;
        margin-top: 5px;
      }
    }
    &-desc {
      color: #999;
      font-size: 14px;
      line-height: 18px;
      & p {
        margin-top: 20px;
      }
    }
    &-kf {
      margin-top: 60px;
      @mixin size 160px, 36px;
      padding: 0;
    }
  }
  &-msg {
    flex: 1;
    margin-left: 34px;
    padding: 0 40px;
    background-color: var(--white);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 3px 20px rgba(153, 153, 153, 0.4);
    &-head {
      height: 124px;
      display: flex;
      align-items: center;
      justify-content: center;
      &-title {
        font-size: 32px;
        &--small {
          font-size: 14px;
          color: #999;
          margin-top: 5px;
        }
        &--update {
          text-align: center;
          font-size: 24px;
        }
      }
    }
    &-main {
      flex: 1;
      border-top: 1px dotted #ccc;
      border-bottom: 1px dotted #ccc;
      &-item {
        margin-top: 32px;
        display: flex;
        align-items: center;
      }
      &-title {
        width: 94px;
        font-size: 16px;
        color: #333;
        font-weight: 700;
      }
      &-text {
        font-size: 16px;
        color: #555;
      }
      &-checkpay {
        display: flex;
        align-items: center;
        &-alipay {
          @mixin size 26px;
          background: url(~@/assets/img/alipay-big.png) center/cover no-repeat;
          margin-right: 4px;
        }
        &-tip {
          font-size: 14px;
          color: #999;
          margin-left: 10px;
        }
      }
    }
    &-foot {
      height: 120px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 14px;
      color: #555;
      &-symbol {
        color: #26b3eb;
      }
      &-money {
        font-size: 32px;
        background-image: -webkit-gradient(
          linear,
          right top,
          left top,
          from(#2edadc),
          to(#26b3eb)
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        display: inline-block;
        color: #26b3eb;
        &--del {
          color: #999;
          margin-left: 5px;
        }
      }
      &-btn {
        @mixin size 200px, 50px;
        padding: 0;
        background: linear-gradient(to right, #26b3eb, #2edadc);
        color: #fff;
        border: 0;
        margin-left: 40px;
        &-disable {
          @mixin size 200px, 50px;
          margin-left: 40px;
          color: #fff !important;
          background: rgba(212, 212, 212, 1) !important;
        }
        &:focus {
          background: linear-gradient(to right, #26b3eb, #2edadc) !important;
          color: #fff !important;
        }
        &:hover {
          background: linear-gradient(
            to right,
            rgba(38, 179, 235, 0.5),
            rgba(46, 218, 220, 0.5)
          ) !important;
          color: #fff !important;
        }
      }
    }
  }
  &-card {
    &-head {
      display: flex;
      align-items: center;
      padding-bottom: 24px;
      border-bottom: 1px dotted #ccc;
    }
    &-bg {
      @mixin size 60px;
      margin-right: 24px;
      &-one {
        background: url(~@/assets/img/colud1.png) 0 center no-repeat;
      }
      &-team {
        background: url(~@/assets/img/colud2.png) 0 center no-repeat;
      }
    }
    &-title {
      font-size: 20px;
      color: #333;
      line-height: 1;
      padding: 10px 0 5px;
      &-small {
        font-size: 12px;
        color: #555;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/public/BuyKnow.vue